export const jobDescriptionMaxChars = 1500
export const bioDescriptionMaxChars = 1500
export const jobBountySuggestionValues = [100, 250,  500, 750]
export const commendationMaxChars = 500
export const emailToPosterMaxChars = 1500
export const jobTitleMaxChars = 100
export const jobBountyFeeAsPercentage = 0.10